export const IMAGE_TYPE = 'imageFile'
export type FileTypes = 'docFile' | 'audioFile' | 'imageFile' | 'otherFile' | 'videoFile' | 'tableFile' | 'archiveFile' | 'unplayableVideoFile'

export const fileTypes = new Map<string, FileTypes>([
  ['txt', 'docFile'],
  ['log', 'docFile'],
  ['ini', 'docFile'],
  ['conf', 'docFile'],
  ['cfg', 'docFile'],
  ['yaml', 'docFile'],
  ['yml', 'docFile'],
  ['json', 'docFile'],
  ['properties', 'docFile'],
  ['env', 'docFile'],
  ['md', 'docFile'],
  ['rtf', 'docFile'],
  ['doc', 'docFile'],
  ['docx', 'docFile'],
  ['html', 'docFile'],
  ['pdf', 'docFile'],
  ['odt', 'docFile'],
  ['fb2', 'docFile'],
  ['epub', 'docFile'],
  ['mobi', 'docFile'],
  ['djvu', 'docFile'],

  ['wav', 'audioFile'],
  ['aiff', 'audioFile'],
  ['m4a', 'audioFile'],
  ['ape', 'audioFile'],
  ['flac', 'audioFile'],
  ['mp3', 'audioFile'],
  ['mp2', 'audioFile'],
  ['ogg', 'audioFile'],
  ['aa', 'audioFile'],
  ['aac', 'audioFile'],
  ['ac3', 'audioFile'],
  ['adx', 'audioFile'],
  ['ahx', 'audioFile'],

  ['bmp', IMAGE_TYPE],
  ['ecw', IMAGE_TYPE],
  ['gif', IMAGE_TYPE],
  ['ico', IMAGE_TYPE],
  ['ilbm', IMAGE_TYPE],
  ['jpeg', IMAGE_TYPE],
  ['jpg', IMAGE_TYPE],
  ['jpeg2000', IMAGE_TYPE],
  ['mrsid', IMAGE_TYPE],
  ['pcx', IMAGE_TYPE],
  ['png', IMAGE_TYPE],
  ['psd', IMAGE_TYPE],
  ['tga', IMAGE_TYPE],
  ['tiff', IMAGE_TYPE],
  ['webp', IMAGE_TYPE],
  ['xbm', IMAGE_TYPE],
  ['xps', IMAGE_TYPE],
  ['rla', IMAGE_TYPE],
  ['rpf', IMAGE_TYPE],
  ['pnm', IMAGE_TYPE],

  ['mp4', 'videoFile'],
  ['m4v', 'videoFile'],
  ['mov', 'videoFile'],
  ['mkv', 'videoFile'],
  ['wmv', 'videoFile'],
  ['flv', 'videoFile'],
  ['webm', 'videoFile'],

  ['zip', 'archiveFile'],
  ['rar', 'archiveFile'],
  ['tar', 'archiveFile'],
  ['7z', 'archiveFile'],
  ['tar-gz', 'archiveFile'],
  ['cab', 'archiveFile'],
  ['gz', 'archiveFile'],
  ['gzip', 'archiveFile'],
  ['sit', 'archiveFile'],
  ['sitx', 'archiveFile'],
  ['tgz', 'archiveFile'],
  ['xar', 'archiveFile'],
  ['zipx', 'archiveFile'],
  ['xl', 'tableFile'],
  ['xls', 'tableFile'],
  ['xlsx', 'tableFile'],
  ['csv', 'tableFile'],
  ['et', 'tableFile'],
  ['ett', 'tableFile'],
  ['fods', 'tableFile'],
  ['ods', 'tableFile'],
  ['ots', 'tableFile'],
  ['sxc', 'tableFile'],
  ['xltm', 'tableFile'],
  ['xltx', 'tableFile'],
  ['xml', 'tableFile'],
  ['gsheet', 'tableFile'],
  ['xla', 'tableFile'],
  ['avi', 'unplayableVideoFile'],
  ['asf', 'unplayableVideoFile'],
  ['mpg', 'unplayableVideoFile'],
  ['mpeg', 'unplayableVideoFile'],
  ['wmv', 'unplayableVideoFile'],
])

export const getFileTypeByName = (name: string) => {
  const fileExtension = getFileExtension(name)
  if (!fileExtension) return 'unknownFile'
  return fileTypes.get(fileExtension) ?? 'unknownFile'
}

export const isAudioFile = (filename: string): boolean => {
  const fileExtension = getFileExtension(filename)
  if (!fileExtension) return false
  return fileTypes.get(fileExtension) === 'audioFile'
}

export const isImageFile = (filename: string): boolean => {
  const fileExtension = getFileExtension(filename)
  if (!fileExtension) return false
  return fileTypes.get(fileExtension) === IMAGE_TYPE
}

export const isVideoFile = (filename: string): boolean => {
  const fileExtension = getFileExtension(filename)
  if (!fileExtension) return false
  return fileTypes.get(fileExtension) === 'videoFile'
}

const getFileExtension = (filename: string): string | undefined => {
  return filename.split('.').at(-1)?.toLowerCase()
}
